import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const RoutinesPage = lazy(async () => {
  const m = await import("@/features/gym/components/routines-page");
  return { default: m.RoutinesPage };
});

interface RoutinesSearch {
  /** "New routine" dialog open (`?new=1`) — copyable/shareable state. */
  new?: "1";
}

export const routinesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/routines",
  validateSearch: (search: Record<string, unknown>): RoutinesSearch =>
    // CC-18: also accepts the NUMBER 1. TanStack JSON-parses pasted `?new=1`
    // as number 1 (not string), and without this case the param was discarded
    // during boot and the deep-link dialog never opened.
    search.new === "1" || search.new === 1 ? { new: "1" } : {},
  component: () => (
    <Suspense fallback={null}>
      <RoutinesPage />
    </Suspense>
  ),
});
